/**
 * Add product compare html to compare bar
 */
function appendProduct(productHandle) {
	const compareBarList = document.getElementById('tpt-compare__bar-product--list');
	const productUrl = `/products/${productHandle}?section_id=tpt-compare-top-bar-item`;

	fetch(productUrl)
		.then((response) => response.text())
		.then((responseText) => {
			const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
			const sectionElement = responseHTML.querySelector('.shopify-section');

			compareBarList.insertAdjacentHTML('afterbegin', sectionElement.innerHTML);
		})
		.finally(() => {
			updateCountItem();
			toggleCompareBar(true);
			syncCompareButtonsActive();
		});
}

/**
 * Show list item compare
 */

async function renderCompareTopbarProducts() {
	let compareHandle = JSON.parse(sessionStorage.getItem('tpt_compare_list')) || [];
	const compareBarList = document.getElementById('tpt-compare__bar-product--list');

	for (const handle of compareHandle) {
		const fetchUrl = `/products/${handle}?section_id=tpt-compare-top-bar-item`;

		try {
			const response = await fetch(fetchUrl);
			const responseText = await response.text();
			const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
			const sectionElement = responseHTML.querySelector('.shopify-section');

			compareBarList.insertAdjacentHTML('beforeend', sectionElement.innerHTML);
		} catch (error) {
			console.error(`Error fetching ${fetchUrl}:`, error);
		}
	}
}

/**
 * Trigger remove item
 */

function triggerRemoveItemCompare(productHandle) {
	document.querySelector(`tpt-compare-remove[data-product-handle="${productHandle}"]`).click();
	syncCompareButtonsActive();
}

/**
 * Check all button compare active or unactive
 */

function syncCompareButtonsActive() {
	let compareList = [];
	try {
		compareList = JSON.parse(sessionStorage.getItem('tpt_compare_list')) || [];
	} catch {}

	const compareButtons = document.querySelectorAll('tpt-compare-button[data-product-handle]');

	if (compareButtons) {
		compareButtons.forEach((button) => {
			const handle = button.dataset.productHandle;

			if (compareList.includes(handle)) {
				button.classList.add('active');
			} else {
				button.classList.remove('active');
			}
		});
	}
}

/**
 * Show compare bar
 */

function toggleCompareBar(status) {
	const compareBar = document.querySelector('.tpt-compare__bar');

	updateStatusCompareBar();

	if (status) {
		compareBar.classList.add('active');
		setTimeout(() => {
			const focusElement = compareBar.querySelector('tpt-compare-trigger');
			trapFocus(compareBar, focusElement);
		}, 400);
	} else {
		compareBar.classList.remove('active');
	}
}

/**
 * Update compare status
 */
function updateStatusCompareBar() {
	const compareBar = document.querySelector('.tpt-compare__bar');
	const count = getCompareCount();

	if (count) {
		compareBar.classList.remove('tpt-compare__bar--empty');
	} else {
		compareBar.classList.add('tpt-compare__bar--empty');
	}
}

function updateCountItem() {
	const count = getCompareCount();
	document.querySelector('.tpt-compare-count').innerHTML = count;
}

/**
 * Count compare item
 */

function getCompareCount() {
	try {
		const list = JSON.parse(sessionStorage.getItem('tpt_compare_list'));
		return Array.isArray(list) ? list.length : 0;
	} catch {
		return 0;
	}
}

/**
 * Compare button element
 */
if (!customElements.get('tpt-compare-button')) {
	customElements.define(
		'tpt-compare-button',
		class TptCompareButton extends HTMLElement {
			constructor() {
				super();
				this.handle = this.dataset.productHandle;
				this.storageKey = 'tpt_compare_list';

				this.onClick = this.onClick.bind(this);
				this.addEventListener('keypress', this.keyPress);
			}

			connectedCallback() {
				if (!this.handle) return;

				this.addEventListener('click', this.onClick);

				// Check active state on load
				if (this.isInCompareList()) {
					this.classList.add('active');
				}
			}

			keyPress(e) {
				if (e.key === 'Enter') {
					this.onClick();
				}
			}

			disconnectedCallback() {
				this.removeEventListener('click', this.onClick);
			}

			getCompareList() {
				try {
					return JSON.parse(sessionStorage.getItem(this.storageKey)) || [];
				} catch {
					return [];
				}
			}

			setCompareList(list) {
				sessionStorage.setItem(this.storageKey, JSON.stringify(list));
			}

			isInCompareList() {
				return this.getCompareList().includes(this.handle);
			}

			onClick() {
				let list = this.getCompareList();

				if (list.includes(this.handle)) {
					// Remove item
					list = list.filter((item) => item !== this.handle);
					this.classList.remove('active');

					triggerRemoveItemCompare(this.handle);
				} else {
					// Add item to the beginning
					list.unshift(this.handle);
					this.classList.add('active');

					// Add item to compare bar
					appendProduct(this.handle);
				}

				this.setCompareList(list);
			}
		},
	);
}

/**
 * Compare button remove
 */
if (!customElements.get('tpt-compare-remove')) {
	customElements.define(
		'tpt-compare-remove',
		class TptCompareRemove extends HTMLElement {
			constructor() {
				super();

				this.handle = this.dataset.productHandle;
			}

			connectedCallback() {
				this.addEventListener('click', this.removeCompare.bind(this));
				this.addEventListener('keypress', this.keyPress.bind(this));
			}

			keyPress(e) {
				if (e.key === 'Enter') {
					this.removeCompare();
				}
			}

			removeCompare() {
				const compareList = JSON.parse(sessionStorage.getItem('tpt_compare_list')) || [];

				if (!compareList.length) return;

				const newList = compareList.filter((item) => item !== this.handle);

				sessionStorage.setItem('tpt_compare_list', JSON.stringify(newList));

				const compareItem = this.closest('[data-compare-item]');

				updateCountItem();
				updateStatusCompareBar();
				toggleCompareBar(true);

				setTimeout(() => {
					if (compareItem) {
						compareItem.remove();

						syncCompareButtonsActive();
					}
				}, 200);
			}
		},
	);
}

/**
 * Compare trigger button
 */
if (!customElements.get('tpt-compare-trigger')) {
	customElements.define(
		'tpt-compare-trigger',
		class TptCompareTrigger extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.toggleCompareBar.bind(this));
				this.addEventListener('keypress', this.keyPress);
			}

			keyPress(e) {
				if (e.key === 'Enter') {
					this.toggleCompareBar();
				}
			}

			toggleCompareBar() {
				const compareBar = document.querySelector('.tpt-compare__bar');
				compareBar.classList.toggle('active');
			}
		},
	);
}

/**
 * Button clear all
 */

if (!customElements.get('tpt-compare-clear')) {
	customElements.define(
		'tpt-compare-clear',
		class TptCompareClear extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.clearAllCompare.bind(this));
			}

			clearAllCompare() {
				sessionStorage.removeItem('tpt_compare_list');
				document.querySelectorAll('[data-compare-item]').forEach((el) => el.remove());
				toggleCompareBar(false);
				updateCountItem();
				syncCompareButtonsActive();
			}
		},
	);
}

/**
 * Append product compare when page load
 */

document.addEventListener('DOMContentLoaded', () => {
	updateCountItem();
	renderCompareTopbarProducts();
	updateStatusCompareBar();
});

/**
 * Page compare
 */

function checkEmptyListCompare() {
	let handles = [];
	try {
		handles = JSON.parse(sessionStorage.getItem('tpt_compare_list')) || [];
	} catch {}

	if (!handles.length) {
		document.body.classList.add('tpt-compare-list__empty');
		document.body.classList.remove('tpt-compare-loaded');
		return;
	}
}

async function renderComparePageAuto() {
	const STORAGE_KEY = 'tpt_compare_list';
	const body = document.getElementById('tpt-compare-body');
	const head = document.getElementById('tpt-compare-head');

	if (!body || !head) return;

	let handles = [];
	try {
		handles = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || [];
	} catch {}

	body.innerHTML = '';
	head.querySelectorAll('td').forEach((td) => td.remove());

	if (!handles.length) {
		document.body.classList.add('tpt-compare-list__empty');
		document.body.classList.remove('tpt-compare-loaded');
		return;
	}

	const fieldMap = new Map(); // key -> { label, row }

	for (const handle of handles) {
		try {
			const fetchUrl = `/products/${handle}?section_id=tpt-compare-page-data`;

			const response = await fetch(fetchUrl);
			const responseText = await response.text();
			const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
			const sectionElement = responseHTML.querySelector('.shopify-section');

			const productEl = sectionElement.querySelector('[data-compare-product]');
			if (!productEl) continue;

			// Add column header
			head.insertAdjacentHTML('beforeend', `<td></td>`);

			const fields = productEl.querySelectorAll('[data-compare-field]');

			fields.forEach((field) => {
				const key = field.dataset.key;
				const label = field.dataset.label || key;

				// Create row if not exist
				if (!fieldMap.has(key)) {
					const row = document.createElement('tr');
					row.innerHTML = `<th>${label}</th>`;
					body.appendChild(row);

					fieldMap.set(key, { row });
				}

				fieldMap.get(key).row.insertAdjacentHTML('beforeend', `<td>${field.innerHTML}</td>`);
			});
		} catch (err) {
			console.error('Compare auto render failed:', handle, err);
		}
	}

	document.body.classList.add('tpt-compare-loaded');
}

document.addEventListener('DOMContentLoaded', renderComparePageAuto);

/**
 * Remove item in table compare
 */

if (!customElements.get('tpt-compare-remove-col')) {
	customElements.define(
		'tpt-compare-remove-col',
		class TptCompareRemoveCol extends HTMLElement {
			constructor() {
				super();
				this.addEventListener('click', this.handleRemove.bind(this));
				this.addEventListener('keypress', this.keyPress.bind(this));
			}

			keyPress(event) {
				if (event.key === 'Enter') {
					this.handleRemove(event);
				}
			}

			handleRemove(e) {
				e.preventDefault();
				e.stopPropagation();

				const handle = this.dataset.productHandle;
				if (!handle) return;

				this.removeFromSessionStorage(handle);
				this.removeColumnDom();
				checkEmptyListCompare();
				updateCountItem();
				syncCompareButtonsActive();
			}

			/* =========================
			 * REMOVE FROM SESSION STORAGE
			 * ========================= */
			removeFromSessionStorage(handle) {
				const STORAGE_KEY = 'tpt_compare_list';
				let list = [];

				try {
					list = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || [];
				} catch {}

				list = list.filter((item) => item !== handle);
				sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list));
			}

			/* =========================
			 * REMOVE COLUMN BY INDEX
			 * ========================= */
			removeColumnDom() {
				// TD đang chứa button remove
				const currentTd = this.closest('td');
				if (!currentTd) return;

				const row = currentTd.parentElement; // <tr>
				const colIndex = Array.from(row.children).indexOf(currentTd);

				if (colIndex === -1) return;

				const table = this.closest('table');
				if (!table) return;

				// Remove toàn bộ cell cùng index
				table.querySelectorAll('tr').forEach((tr) => {
					const cell = tr.children[colIndex];
					if (cell) cell.remove();
				});

				// Empty state
				const headRow = table.querySelector('#tpt-compare-head');
				if (headRow && headRow.children.length <= 1) {
					table.querySelector('tbody').innerHTML = `
            <tr>
              <td colspan="100%">No products to compare</td>
            </tr>
          `;
				}
			}
		},
	);
}
